import { render, staticRenderFns } from "./TitleBar.vue?vue&type=template&id=bd41c3f6"
import script from "./TitleBar.vue?vue&type=script&setup=true&lang=js"
export * from "./TitleBar.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports